import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import React from 'react';
import './weconnect.css';
let data = require('./lang/lang.json');

function ExpositionPage() {
  const text = data[localStorage.getItem('language')];
  const expositions = [
    {
      title: text.exposition_title_3,
      subtitle: text.exposition_subtitle_3,
      body: text.exposition_text_3,
      image: 'images/exposition/3.png',
    },
    {
      title: text.exposition_title_1,
      subtitle: text.exposition_subtitle_1,
      body: text.exposition_text_1,
      image: 'images/exposition/2.png',
    },
    {
      title: text.exposition_title_2,
      subtitle: text.exposition_subtitle_2,
      body: text.exposition_text_2,
      image: 'images/exposition/1.png',
    },
  ];
  return (
    <section className='main-container connect'>
      <div className='description-banner'>
        <h2 className='title-generic'>{text.exposition}</h2>
        <p dangerouslySetInnerHTML={{ __html: text.exposition_desc }}></p>
      </div>
      <div className='we-connect-section'>
        {expositions.map(({ title, subtitle, body, image }, index) => {
          // alternate the image between the left and the right column
          const imageFirst = index % 2 === 0;
          const picture = (
            <div className='col-lg-6 pl-0'>
              <img src={image} alt='' />
            </div>
          );
          const description = (
            <div className='main-description-banner col-lg-6'>
              <p className='row m-0' dangerouslySetInnerHTML={{ __html: title }}></p>
              <p className='row m-0' dangerouslySetInnerHTML={{ __html: subtitle }}></p>
              <div className='info-block'>
                <p dangerouslySetInnerHTML={{ __html: body }}></p>
              </div>
            </div>
          );
          return (
            <div key={image}>
              <div className='generic-container'>
                <div className={`row m-0 ${imageFirst ? '' : 'mobile-reverse'}`}>
                  {imageFirst ? picture : description}
                  {imageFirst ? description : picture}
                </div>
              </div>
              {index < expositions.length - 1 && (
                <div className='col-12'>
                  <img src='images/we-read/line1.svg' className='img-fluid' alt='item' title='item' />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
const mapDispatchToProps = (dispatch) => ({
  setLanguage: (language) => dispatch({ type: 'SET_LANGUAGE', language }),
});

const mapStateToProps = (state) => {
  return { language: state.language };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ExpositionPage));
